"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("../style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _circleSmall = _interopRequireDefault(require("cccisd-icons/circle-small"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark3"));
require("react-dates/initialize");
require("./datePicker.scss");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CalendarDialog = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function CalendarDialog(props) {
    var _this;
    _classCallCheck(this, CalendarDialog);
    _this = _callSuper(this, CalendarDialog, [props]);
    _defineProperty(_this, "changeSessionHeld", function (held) {
      _this.props.changeSessionHeld(held);
    });
    _defineProperty(_this, "onDateSelect", function (date) {
      _this.setState({
        date: date.startDate
      });
      _this.props.onDateSelect(date);
    });
    _this.state = {
      date: {}
    };
    return _this;
  }
  _inherits(CalendarDialog, _React$Component);
  return _createClass(CalendarDialog, [{
    key: "render",
    value: function render() {
      var disabled = true;
      if (this.props.sessionHeld === false || this.props.sessionHeld === true && (0, _isEmpty2["default"])(this.state.date) || this.props.sessionHeld === true && !this.state.date.isAfter((0, _moment["default"])(), 'day')) {
        disabled = false;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: '4rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-around',
          margin: '0 6rem 0 6rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          // padding: '0 12rem 0 12rem',
          width: '25%'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: {
          padding: '6px 8px',
          width: '100%'
        },
        className: (0, _classnames["default"])('btn btn-secondary', {
          active: this.props.sessionHeld
        }),
        onClick: this.changeSessionHeld.bind(null, true)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].held
      }, /*#__PURE__*/_react["default"].createElement(_circleSmall["default"], null)), "Held"), /*#__PURE__*/_react["default"].createElement("div", null, "-- OR --"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: {
          padding: '6px 8px',
          width: '100%'
        },
        className: (0, _classnames["default"])('btn btn-secondary', {
          active: this.props.sessionHeld === false
        }),
        onClick: this.changeSessionHeld.bind(null, false)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].missed
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "Missed")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          border: '1px solid lightgrey',
          width: '1px'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-calendar', _style["default"].calendarPicker)
      }, /*#__PURE__*/_react["default"].createElement(_reactDates.DayPickerRangeController, {
        startDate: this.props.selectedDate,
        endDate: this.props.selectedDate // momentPropTypes.momentObj or null,
        ,
        onDatesChange: this.onDateSelect // momentPropTypes.momentObj or null,
        ,
        focusedInput: "startDate",
        hideKeyboardShortcutsPanel: true
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '3rem',
          marginRight: '12%',
          position: 'relative'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '318px',
          textAlign: 'right'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: {
          padding: '0.5rem 2rem 0.5rem 2rem'
        },
        className: "btn btn-primary",
        onClick: this.props.onCalendarSubmit,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null), " OK"), this.props.sessionHeld === true && !(0, _isEmpty2["default"])(this.state.date) && this.state.date.isAfter((0, _moment["default"])(), 'day') && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: '#a94442',
          fontSize: '0.9em'
        }
      }, "* Cannot hold session in the future"))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(CalendarDialog, "propTypes", {
  changeSessionHeld: _propTypes["default"].func,
  sessionHeld: _propTypes["default"].bool,
  selectedDate: _propTypes["default"].object,
  onDateSelect: _propTypes["default"].func,
  onCalendarSubmit: _propTypes["default"].func,
  notSubmitted: _propTypes["default"].bool,
  label: _propTypes["default"].string
});
_defineProperty(CalendarDialog, "defaultProps", {
  label: 'Session'
});